import React from "react";
import { finalCta, brand, cta, media } from "../../content/siteContent";
import { CTAButton } from "./primitives";
import { LineReveal } from "../motion/Reveal";
import { scrollToId } from "../../hooks/useLenis";
import { track, EVENTS } from "../../lib/analytics";

export const FinalCTA = () => {
  const prospectus = () => {
    track(EVENTS.PROSPECTUS_CTA, { location: "final" });
    scrollToId("prospectus");
  };
  const consult = () => {
    track(EVENTS.CONSULTATION_CTA, { location: "final" });
    scrollToId("prospectus");
  };
  return (
    <section data-testid="final-cta-section" className="relative bg-navy overflow-hidden grain">
      <div className="absolute inset-0">
        <img src={media.finalCta} alt="" aria-hidden="true" loading="lazy" className="h-full w-full object-cover opacity-25" />
        <div className="absolute inset-0 bg-navy/80" />
      </div>
      <div className="container-page relative py-28 lg:py-40 text-center">
        <p className="eyebrow text-teal mb-6">{brand.positioningPrinciple}</p>
        <h2 className="font-display font-extrabold tracking-tight text-white text-4xl sm:text-5xl lg:text-6xl leading-[1.05] max-w-3xl mx-auto">
          <LineReveal lines={["Learn the system.", "Apply it. Prove it."]} />
        </h2>
        <p className="mt-8 text-white/75 text-base lg:text-lg leading-relaxed max-w-2xl mx-auto">
          {finalCta.supporting}
        </p>
        <div className="mt-10 flex flex-col sm:flex-row justify-center gap-4">
          <CTAButton data-testid="final-prospectus-cta" onClick={prospectus} withArrow>
            {cta.prospectusShort}
          </CTAButton>
          <CTAButton data-testid="final-consultation-cta" variant="outlineLight" onClick={consult}>
            {cta.consultation}
          </CTAButton>
        </div>
        <p className="mt-12 font-display font-extrabold text-gold tracking-[0.3em] uppercase text-sm">
          {brand.tagline}
        </p>
      </div>
    </section>
  );
};
